import React from 'react';
import Svg from '../Svg';
import IIconSvg from './IIconSvg';

const ArrowRight: React.FC<IIconSvg> = ({ fill, bgColor, size = '16px', className }) => (
  <Svg className={className} fill={fill} color={bgColor} size={size} path="" viewBox="0 0 24 24">
    <path d="M14.4301 18.82C14.2401 18.82 14.0501 18.75 13.9001 18.6C13.6101 18.31 13.6101 17.83 13.9001 17.54L19.4401 12L13.9001 6.46C13.6101 6.17 13.6101 5.69 13.9001 5.4C14.1901 5.11 14.6701 5.11 14.9601 5.4L21.0301 11.47C21.3201 11.76 21.3201 12.24 21.0301 12.53L14.9601 18.6C14.8101 18.75 14.6201 18.82 14.4301 18.82Z" />
    <path d="M20.33 12.75H3.5C3.09 12.75 2.75 12.41 2.75 12C2.75 11.59 3.09 11.25 3.5 11.25H20.33C20.74 11.25 21.08 11.59 21.08 12C21.08 12.41 20.74 12.75 20.33 12.75Z" />
  </Svg>
);

export default ArrowRight;
